export const IVRPaths = {
    ivrDetail: ":ivrId",
} as const;
